//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { axiosGet } from '../../../../axios/axios.js'

export default {
  data: function () {
    return {
      loading: false,
      userInfo: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    user: {
      handler: function (val) {
        if (val) {
          this.load()
        }
      },
      immediate: true
    }
  },
  methods: {
    load: function () {
      if (this.user.employee) {
        this.loading = true
        axiosGet({
          url: '/service/obj/properties?id=' + this.user.employee.id + '&change=false',
          onSuccess: (response) => {
            this.userInfo = response.data.result
          },
          onFailure: ''
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}

